import { render } from "./ChangeGroupDialog.vue?vue&type=template&id=310cedd6&scoped=true"
import script from "./ChangeGroupDialog.vue?vue&type=script&lang=js"
export * from "./ChangeGroupDialog.vue?vue&type=script&lang=js"

import "./ChangeGroupDialog.vue?vue&type=style&index=0&id=310cedd6&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1847379700/src/basejumper-amplify/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-310cedd6"]])

export default __exports__